/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import "../../styles/info.css";
import MertPhoto from "../../assets/images/MertFoto.jpg";

const InterestsInfoPanel = () => {
  return (
    <div className="info-panel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-file"> </i>
          interestsInfo.mrt
        </div>
      </div>
      <div className="info-content">
        <p className="info-entrance">// My fake instagram feed</p>
      </div>
      <div className="person-card">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created a month ago</p>
        </div>
      </div>
      <div className="skills-container interests-image-2"></div>

      <div className="person-card mt-25">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created two months ago</p>
        </div>
      </div>
      <div className="skills-container interests-image-1"></div>
      <div className="person-card mt-25">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created two months ago</p>
        </div>
      </div>
      <div className="skills-container interests-image-4"></div>
      <div className="person-card mt-25">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created two months ago</p>
        </div>
      </div>
      <div className="skills-container interests-image-3"></div>

      <div className="info-content mt-25">
        <p className="info-entrance">
          // Some nonsense code to impress my friends
        </p>
      </div>

      <div className="person-card">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created three months ago</p>
        </div>
      </div>
      <div className="skills-container interest-code">
        <span class="const-color">const</span>{" "}
        <span class="variable-color">mert</span> = {"{"}
        <br />
        &nbsp;&nbsp;<span class="variable-color">location</span>:{" "}
        <span className="string-color">"Rotterdam, NL"</span>,
        <br />
        &nbsp;&nbsp;<span class="variable-color">profession</span>:
        <span className="string-color">"Full-Stack Developer"</span>,
        <br />
        &nbsp;&nbsp;<span class="variable-color">likes</span>:{" "}
        <span className="bracket">{"["}</span>
        <span className="string-color">
          "React", "Node.js", "SQL", "building stuff that nobody asked for"
        </span>
        <span className="bracket">{"]"}</span>,
        <br />
        &nbsp;&nbsp;<span class="variable-color">hobbies</span>:{" "}
        <span className="bracket">{"["}</span>{" "}
        <span className="string-color">
          "sailing", "gaming", "long walks", "debugging at 2AM"
        </span>
        <span className="bracket">{"]"}</span>,
        <br />
        &nbsp;&nbsp;<span class="variable-color">formerLife</span>:{" "}
        <span className="string-color">
          "licensed sailor & childhood sea warrior"
        </span>
        ,
        <br />
        &nbsp;&nbsp;<span class="variable-color">currentMood</span>:{" "}
        <span className="string-color">"let's ship it 🚀"</span>,
        <br />
        &nbsp;&nbsp;<span class="variable-color">lovesCoffe</span>:{" "}
        <span className="true-color-text">true</span>
        <br />
        {"};"}
        <br />
        <br />
        <span class="const-color">const</span>{" "}
        <span class="function-color">buildCoolStuff</span> = () =&gt; {"{"}
        <br />
        &nbsp;&nbsp;<span class="const-color">const</span>{" "}
        <span class="variable-color">idea</span> ={" "}
        <span className="string-color">"something weird but useful"</span>;
        <br />
        &nbsp;&nbsp;<span class="const-color">const</span>{" "}
        <span class="variable-color">techStack</span> ={" "}
        <span className="string-color">
          {" "}
          <span className="bracket">{"["}</span>
          "Next.js", "Raspberry Pi", "CSS"{" "}
          <span className="bracket">{"]"}</span>
        </span>
        ;
        <br />
        &nbsp;&nbsp;<span class="variable-color">mert</span>.energy++;
        <br />
        &nbsp;&nbsp;<span className="return-color">return</span>{" "}
        <span class="variable-color">idea</span> +
        <span className="string-color"> " built with love 💜"</span>;
        <br />
        {"};"}
        <br />
        <br />
        <span class="function-color">buildCoolStuff();</span>
      </div>
    </div>
  );
};

export default InterestsInfoPanel;
